import React, { useState } from "react";
import styled from "styled-components";
import DomeHeader from "../components/DomeHeader";
import Breakpoints from "../components/styles/Breakpoints";
import { Colors } from "../components/styles/Colors";
import { DomeText, AcmeCompressed } from "../components/typography";
import YouTube from "react-youtube";
import Image from "gatsby-image";

const Wrapper = styled.div`
  background: ${Colors.sage};

  .title {
    padding: 64px 32px;

    h2 {
      margin: 0px auto;
      max-width: 800px;
      font-family: ${AcmeCompressed};
      line-height: 1;

      color: ${Colors.white};
      text-align: center;
      font-size: 64px;

      @media ${Breakpoints.desktop} {
        margin: 24px auto 80px;
        font-size: 120px;
      }
    }

    ${DomeText} {
      text-align: center;
      display: block;
      color: ${Colors.white};
    }
  }
`;

const Video = styled.div`
  padding: 0px 30px 50px 30px;

  @media ${Breakpoints.desktop} {
    padding: 0px 130px 100px 130px;
  }

  .vid-container {
    position: relative;
    padding-bottom: 120%;
    height: 0;

    @media ${Breakpoints.desktop} {
      padding-bottom: 56.25%; /* 16:9 */
    }

    & > div:first-child, iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }

    & > div:first-child {
      opacity: 0;
      transition: opacity .3s;
    }

    .play-button {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 10;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: opacity .3s;

      svg {
        width: 50px;
        transition: opacity .3s;
        position: relative;
        z-index: 10;
      }

      .gatsby-image-wrapper {
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        transition: opacity .3s;
      }

      &:hover {
        svg {
          opacity: .5;
        }
      }
    }

    &.playing {
      & > div:first-child {
        opacity: 1;
      }

      .play-button {
        opacity: 0;
        pointer-events: none;
      }
    }
  }
`

export default function KaramoVideo({ id, placeholder }) {
  const [playing, setPlaying] = useState(false)
  const [player, setPlayer] = useState(null)

  const onReady = (event) => {
    setPlayer(event.target)
  }

  function play () {
    setPlaying(true)
    player.playVideo()
  }

  return (
    <Wrapper>
      <div className="title">
        <DomeHeader text="Where I've Been" centered />
        <h2>Watch My Journey</h2>
      </div>

      <Video>
        <div className={`vid-container ${playing ? 'playing' : 'paused'}`}>
          <YouTube
            videoId={id}
            onReady={onReady}
          />

          <div onClick={play} className="play-button">
            <Image style={{ position: 'absolute' }} fluid={placeholder.fluid} />

            <svg viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="25" cy="25" r="25" fill="white"/>
              <path d="M20 16L34 25L20 34V16Z" fill="#565F63"/>
            </svg>
          </div>
        </div>
      </Video>
    </Wrapper>
  );
}
